import React, { useState, useEffect } from 'react';
import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    IconButton,
    Checkbox,
    FormControlLabel,
    Typography,
    Skeleton,
    Grid
} from '@mui/material';
import { DisabledByDefault, RotateLeft, Upload } from '@mui/icons-material';
import configServ from '../../../services/config';
import Swal from 'sweetalert2';

// FUNCTION
const AddItemVideo = ({
    itemData,
    openVideo,
    handleVideoClose,
    editData,
    isEdit,
}) => {
    const [formData, setFormData] = useState({
        video_url: '',
        description: '',
        status: true,
    });
    const [validationError, setValidationError] = useState({});

    // Populate the form if editing
    useEffect(() => {
        if (editData !== null) {
            setFormData(editData);
        } else {
            clearForm();
        }
    }, [editData]);

    const clearForm = () => {
        setFormData({
            video_url: '',
            description: '',
            product_id: '',
            status: true,
        });
        setValidationError({});
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const validate = async () => {
        const errors = {};
        if (!formData.title) errors.title = 'Title is required.';
        if (!formData.video_url) errors.video_url = 'Video URL is required.';

        setValidationError(errors);
        return Object.values(errors).every(error => error === "");
    };

    const handleSubmit = async () => {
        try {
            const errors = await validate();
            if (errors === false) {
                return;
            }
            const dataToSend = {
                ...formData,
                product_id: itemData.id,
                // company_id,
                // user_id
            }
            if (isEdit) {
                const res = await configServ.updateProductVideo(dataToSend);
                if (res.status === 200) {
                    handleVideoClose();
                    clearForm();
                    Swal.fire({
                        'icon': 'success',
                        'title': 'Success',
                        'text': 'Video reference updated successfully to solution.'
                    });
                }
            }
            else {
                const res = await configServ.createProductVideo(dataToSend);
                if (res.status === 200) {
                    handleVideoClose();
                    clearForm();
                    Swal.fire({
                        'icon': 'success',
                        'title': 'Success',
                        'text': 'Video reference added successfully to solution.'
                    });
                }
            }
        }
        catch (e) {
            console.log(e);
        }
    };

    const handleIframe = (params) => {
        try {
            if (params !== '') {
                // Replace 'youtu.be' with 'www.youtube.com/embed' in the URL
                const updatedParams = params.replace("youtu.be", "www.youtube.com/embed");
                console.log("Updated URL:", updatedParams);
                return updatedParams; // Return the updated URL if needed
            }
            else {
                return '';
            }
        } catch (e) {
            console.log("Error:", e);
        }
    };

    return (
        <Dialog
            open={openVideo}
            onClose={handleVideoClose}
            aria-labelledby="form-dialog-title"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle sx={{ p: 0 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" ml={3} fontWeight={700}>
                        {'UPLOAD VIDEO'}
                    </Typography>
                    <IconButton onClick={handleVideoClose} sx={{ fontSize: '36px' }}>
                        <DisabledByDefault color="error" fontSize='36px' />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Grid container alignItems={'center'} spacing={1}>
                    {
                        formData.video_url ?
                            <Grid container item xs={12} justifyContent={'center'}>
                                <iframe width={300} height={150} src={handleIframe(formData.video_url || '')}></iframe>
                            </Grid>
                            :
                            <Grid container item xs={12} justifyContent={'center'}>
                                <Skeleton variant='rectangular' width={300} height={150} />
                            </Grid>
                    }
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            size='small'
                            label="Title"
                            name="title"
                            value={formData.title || ''}
                            onChange={handleChange}
                            error={!!validationError.title}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            size='small'
                            label="Video URL"
                            name="video_url"
                            value={formData.video_url}
                            onChange={handleChange}
                            error={!!validationError.video_url}
                            helperText={validationError.video_url}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            size='small'
                            label="Description"
                            name="description"
                            multiline
                            rows={2}
                            value={formData.description}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid container item xs={12} md={6} justifyContent={'flex-start'}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="status"
                                    checked={Boolean(formData.status)}
                                    onChange={handleChange}
                                />
                            }
                            label="Status"
                        />
                    </Grid>
                    <Grid container item xs={12} md={6} spacing={1}>
                        <Grid item xs={6}>
                            <Button fullWidth onClick={clearForm} variant='contained' color="secondary" startIcon={<RotateLeft />}>
                                Reset
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button fullWidth onClick={handleSubmit} variant='contained' color="primary" startIcon={<Upload />}>
                            {isEdit ? 'Update' : 'Upload'}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default AddItemVideo;
